export const copyRecordedSegment = (entry) => ({
  initialDelayMs: Number(entry?.initialDelayMs) || 0,
  steps: (entry?.steps || []).map(({ action, delayMs }) => ({
    action,
    delayMs: Number(delayMs) || 0,
  })),
});

export const buildNavigationDestinationTarget = ({
  deviceId,
  profileId,
  anchor,
  destination,
}) => {
  const expectedScreenKey = String(destination.endScreen?.screenKey || '')
    .trim()
    .toLowerCase();
  const hasDistinctScreenKey = expectedScreenKey
    && !['unknown', 'in_target_app'].includes(expectedScreenKey);
  return {
    deviceId,
    profileId,
    name: destination.label,
    kind: 'navigation_destination',
    seed: {
      provider: 'recorded_navigation',
      startPointId: destination.id,
    },
    strategies: [{
      id: 'recorded-navigation',
      type: 'recorded_navigation',
      launchDelayMs: 6000,
      anchorStartPointId: anchor.id,
      destinationStartPointId: destination.id,
      anchor: copyRecordedSegment(anchor),
      destination: copyRecordedSegment(destination),
    }],
    verification: {
      foregroundPackageRequired: true,
      ...(hasDistinctScreenKey ? { expectedScreenKey } : {}),
    },
  };
};

export const findNavigationDestinationTarget = (targets, startPointId) => (
  (targets || []).find((target) => (
    target.kind === 'navigation_destination'
    && target.seed?.provider === 'recorded_navigation'
    && target.seed?.startPointId === startPointId
  )) || null
);
